var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mb-2",attrs:{"placeholder":_vm.text,"outlined":"","rounded":"","prepend-inner-icon":"mdi-magnify","hide-details":"","id":"text-field","clearable":""},on:{"click:prepend-inner":_vm.triggerSearch,"click:clear":_vm.triggerClear},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }